/** The words the family sees for recurring templates (skill 13 — no ledger vocabulary). */
import type { AmountMode, RecurringFrequency } from '../data/recurringRepository.js';

export const FREQUENCY_LABELS: Record<RecurringFrequency, string> = {
  weekly: 'Hằng tuần',
  monthly: 'Hằng tháng',
  quarterly: 'Hằng quý',
  yearly: 'Hằng năm',
};

export const AMOUNT_MODE_LABELS: Record<AmountMode, string> = {
  fixed: 'Số tiền cố định',
  estimated: 'Số tiền thay đổi',
};

const LONG_DATE = new Intl.DateTimeFormat('vi-VN', {
  day: 'numeric',
  month: 'numeric',
  timeZone: 'UTC',
});

/**
 * "Hôm nay" / "Ngày mai" for the two days a person plans around, then the date.
 *
 * Both sides are plain YYYY-MM-DD in the household timezone — a due date is a day the family
 * owes something, not an instant, so nothing here converts to or from UTC.
 */
export function dueDateLabel(dueDate: string, timeZone: string): string {
  const today = todayKey(timeZone);

  if (dueDate === today) return 'Hôm nay';
  if (dueDate === addDays(today, 1)) return 'Ngày mai';
  if (dueDate < today) return `Quá hạn ${formatDay(dueDate)}`;
  return `Ngày ${formatDay(dueDate)}`;
}

function todayKey(timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

function formatDay(dayKey: string): string {
  return LONG_DATE.format(new Date(`${dayKey}T00:00:00Z`));
}

/** Calendar arithmetic on a YYYY-MM-DD key. Deliberately not money. */
function addDays(dayKey: string, days: number): string {
  const date = new Date(`${dayKey}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}
